import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { useSelector, useDispatch } from "react-redux";
import { updateActiveTagList } from "../../../GreatIt.Cms/Pages/VideoPage/VideoPage.action";
import { translate } from '../../../Services/translation'

const TagCarousel = (props) => {
    const [tagsAmount, setTagsAmount] = useState(1);
    const [isClicked, setIsClicked] = useState(1);
    const { activeTagList } = useSelector((state) => state.VideoReducer);
    const dispatch = useDispatch();
    const {
        list,
        showCarouselArrows,
    } = props.propData;

    const clickedButton = () => {
        setIsClicked(isClicked + 1);
    }

    const NextArrow = (props) => {
        const { onClick } = props;
        const display = onClick === null ? "none" : "grid";
        return (
            <div className='tc__nextArrow' onClick={onClick} style={{ display }}>
                <span onClick={clickedButton}></span>
            </div>
        );
    }
    const PrevArrow = (props) => {
        const { onClick } = props;
        const display = onClick === null ? "none" : "grid";
        return (
            <div className='tc__prevArrow' onClick={onClick} style={{ display }}>
                <span onClick={clickedButton}></span>
            </div>
        );
    }

    useEffect(() => {
        displayActiveTags();
        const updateTagList = () => {
            const container = document.querySelectorAll(".video-page-other-tag_carousel")[0];
            const currentSlide = container.querySelector(".slick-current");
            const allSlides = container.querySelectorAll(".slick-slide");

            let currentWidth = 0;
            let tagsToShow = 0;
            const containerWidth = container.offsetWidth;
            let foundCurrentSlide = false;

            for (let i = 0; i < allSlides.length; i++) {
                const slide = allSlides[i];
                if (slide === currentSlide) {
                    foundCurrentSlide = true;
                    tagsToShow++;
                    currentWidth += currentSlide.offsetWidth;
                } else if (foundCurrentSlide) {
                    // start from currentslide, count slides coming after that and see if it has space
                    const slideWidth = slide.offsetWidth;
                    if (currentWidth + slideWidth <= containerWidth) {
                        currentWidth += slideWidth;
                        tagsToShow++;
                    } else {
                        // break if no space
                        break;
                    }
                }
            }
            if (tagsToShow !== tagsAmount) {
                setTagsAmount(tagsToShow);
            }
        };
        updateTagList();
        window.addEventListener("resize", updateTagList);
        return () => {
            window.removeEventListener("resize", updateTagList);
        };
    }, [activeTagList, tagsAmount, isClicked]);

    const settings = {
        infinite: false,
        slidesToShow: tagsAmount,
        slidesToScroll: 1,
        variableWidth: true,
        nextArrow: showCarouselArrows === "true" && <NextArrow />,
        prevArrow: showCarouselArrows === "true" && <PrevArrow />,
    };


    const displayActiveTags = () => {
        const tagElements = document.querySelectorAll(".tag-carousel-item__tag");
        const lowercaseActiveTagList = activeTagList.map((tag) => tag.toLowerCase());
        tagElements.forEach((tagElement) => {
            const tag = tagElement.dataset.tag.toLowerCase();

            if (lowercaseActiveTagList.includes(tag)) {
                tagElement.classList.add("tag-carousel-item__tag-active");
            } else {
                tagElement.classList.remove("tag-carousel-item__tag-active");
            }
        });
    };

    const handleClick = (tagElement) => {
        const clickedTag = tagElement.dataset.tag.toLowerCase();

        if (activeTagList.includes(clickedTag)) {
            // Remove the tag from activeTagList
            let updatedTags = activeTagList
                .filter((tag) => tag.toLowerCase() !== clickedTag.toLowerCase())
                .map((tag) => tag.toLowerCase());

            if (updatedTags.length === 0 || !updatedTags.some((tag) => list.includes(tag.toLowerCase()))) {
                // No tags left, add "allTags" back to activeTagList
                dispatch(updateActiveTagList(["alltags"]));
            } else {
                if (updatedTags.includes("alltags")) {
                    // Remove "allTags" if present
                    const allTagsIndex = updatedTags.indexOf("alltags");
                    updatedTags.splice(allTagsIndex, 1);
                }

                dispatch(updateActiveTagList(updatedTags));
            }
        } else {
            // Add the tag to activeTagList if it doesn't already exist
            if (!activeTagList.includes(clickedTag)) {
                let updatedTags = [...activeTagList, clickedTag];

                if (updatedTags.includes("alltags")) {
                    // Remove "allTags" if it is present
                    updatedTags = updatedTags.filter((tag) => tag !== "alltags");
                }
                dispatch(updateActiveTagList(updatedTags));
            }
        }
    };

    const handleAllTagsClick = () => {
        dispatch(updateActiveTagList(["alltags"]));
    };

    return (
        <div className="tag-carousel__container">
            <Slider {...settings}>
                <div className="tag-carousel-item tag-carousel-item-all" key="allTag">
                    <div
                        className={`tag-carousel-item__tag ${activeTagList.includes("allTags") ? "tag-carousel-item__tag-active" : ""}`}
                        data-tag="allTags"
                        onClick={handleAllTagsClick}
                    >
                        <p>{translate('tagcarousel.tags.alltag')}</p>
                    </div>
                </div>
                {list.map((item, index) => (
                    <div
                        className={`tag-carousel-item tag-carousel-item-${index}`}
                        key={index}
                    >
                        <div
                            className={`tag-carousel-item__tag ${activeTagList.includes(item.toLowerCase()) ? "tag-carousel-item__tag-active" : ""}`}
                            data-tag={item}
                            onClick={(e) => handleClick(e.currentTarget)}
                        >
                            <p>{item.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</p>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default TagCarousel;